/**
 * Beach Bar Check widget.
 *
 * Two answers ("Real" / "Nah"), each with an inline follow-up ask revealed after
 * the vote lands. Both follow-up panels ship hidden in the cached HTML, because
 * WP Super Cache serves one file to every visitor; per-visitor state has to be
 * decided here, from the cookie, not in PHP.
 */

function applyState(wrap, value) {
	wrap.querySelectorAll(".check").forEach((card) => {
		const isThis = card.getAttribute("data-value") === value;
		card.classList.toggle("checked", isThis && value !== "");
		card.classList.toggle("not-checked", !isThis || value === "");
	});
	applyFollowup(wrap, value);
}

/**
 * Reveal the panel matching the current answer, hide the other, and collapse
 * everything if the vote was toggled back off.
 */
function applyFollowup(wrap, value) {
	const followup = wrap.querySelector("[data-check-followup]");
	if (!followup) return;

	let anyVisible = false;

	followup.querySelectorAll("[data-followup-panel]").forEach((panel) => {
		const isThis = panel.getAttribute("data-followup-panel") === value && value !== "";
		panel.hidden = !isThis;
		if (isThis) anyVisible = true;
	});

	followup.hidden = !anyVisible;
	followup.classList.toggle("is-open", anyVisible);
}

function readCookie(name) {
	const row = document.cookie.split("; ").find((r) => r.startsWith(`${name}=`));
	return row ? decodeURIComponent(row.split("=").slice(1).join("=")) : "";
}

function applyReasonState(wrap, reason) {
	wrap.querySelectorAll(".reason[data-reason]").forEach((btn) => {
		btn.classList.toggle("selected", btn.getAttribute("data-reason") === reason && reason !== "");
	});
	const thanks = wrap.querySelector("[data-reason-thanks]");
	if (thanks) thanks.hidden = reason === "";
}

function post(action, fields) {
	const form = new FormData();
	form.append("action", action);
	form.append("nonce", window.BarCheck.nonce);
	Object.entries(fields).forEach(([k, v]) => form.append(k, v));

	return fetch(window.BarCheck.ajaxUrl, {
		method: "POST",
		credentials: "same-origin",
		body: form,
	}).then((res) => res.json());
}

export function initBarCheck() {
	if (typeof window.BarCheck === "undefined") return;

	// Restore this visitor's own answers from their cookies on load.
	document.querySelectorAll("[data-bar-check]").forEach((wrap) => {
		const postId = wrap.getAttribute("data-post-id");
		if (!postId) return;

		const val = readCookie(`bar_check_${postId}`);
		if (val) applyState(wrap, val);

		const reason = readCookie(`bar_check_reason_${postId}`);
		if (val === "nah" && reason) applyReasonState(wrap, reason);
	});

	document.addEventListener("click", async (e) => {
		// -------- Real / Nah --------
		const card = e.target.closest(".check[data-value]");
		if (card) {
			const wrap = card.closest("[data-bar-check]");
			if (!wrap) return;

			const postId = wrap.getAttribute("data-post-id");
			const value  = card.getAttribute("data-value");
			if (!postId || !value) return;

			const currentlyChecked = card.classList.contains("checked");
			applyState(wrap, currentlyChecked ? "" : value);

			// Don't leave a stale reason showing under a cleared or flipped vote.
			if (currentlyChecked || value !== "nah") applyReasonState(wrap, "");

			wrap.style.pointerEvents = "none";

			try {
				const json = await post("bar_check_set", { post_id: postId, value: value });
				if (!json.success) throw new Error(json.data?.message || "Failed.");
				applyState(wrap, json.data.value);
			} catch (err) {
				console.error(err);
				applyState(wrap, currentlyChecked ? value : "");
			} finally {
				wrap.style.pointerEvents = "auto";
			}
			return;
		}

		// -------- Nah reason --------
		const reasonBtn = e.target.closest(".reason[data-reason]");
		if (reasonBtn) {
			const wrap = reasonBtn.closest("[data-bar-check]");
			if (!wrap) return;

			const postId = wrap.getAttribute("data-post-id");
			const reason = reasonBtn.getAttribute("data-reason");
			if (!postId || !reason) return;

			const previous = readCookie(`bar_check_reason_${postId}`);
			applyReasonState(wrap, reason);

			try {
				const json = await post("bar_check_reason", { post_id: postId, reason: reason });
				if (!json.success) throw new Error(json.data?.message || "Failed.");
			} catch (err) {
				console.error(err);
				applyReasonState(wrap, previous);
			}
			return;
		}

		// -------- Jump to the comment form --------
		const jump = e.target.closest("[data-followup-jump]");
		if (jump) {
			const target = document.querySelector("#bar-review-form");
			if (!target) return; // Let the anchor behave normally if it isn't there.

			e.preventDefault();
			target.scrollIntoView({ behavior: "smooth", block: "start" });

			// wpDiscuz builds its form on the client, so give it a beat before
			// reaching for the textarea. Never steal focus on a phone, where it
			// would throw up the keyboard mid-scroll.
			if (window.matchMedia("(min-width: 768px)").matches) {
				setTimeout(() => {
					const field = target.querySelector("textarea, .wpd-form textarea");
					if (field) field.focus({ preventScroll: true });
				}, 700);
			}
		}
	});
}
